import styles from './WidgetStyles.module.css';

type InjectedUserMessageBubbleProps = {
    content: string;
};

export function InjectedUserMessageBubble({ content }: InjectedUserMessageBubbleProps) {
    return (
        <li className={`${styles.messageCard} ${styles.injectedUserMessageCard}`}>
            <span className={styles.injectedUserMessageBubble}>{content}</span>
        </li>
    );
}
